// Common USB-serial adapters on ESP32 dev boards (CP210x, CH340, FTDI, native USB).
export const ESP_USB_VENDOR_IDS = [
  0x10c4,
  0x1a86,
  0x0403,
  0x303a,
];

export const BOARDS = {
  esp32: {
    'ESP32 Dev Module': 'esp32:esp32:esp32',
    'ESP32-S3 Dev Module': 'esp32:esp32:esp32s3',
  },
};

export const PINS = {
  'esp32:esp32:esp32': ['TX', '2', 'RX', '4', '5', '12', '13', '14', '15', '16', '17', '18', '19', '21', '22', '23', '25', '26', '27', '32', '33', '34', '35', '36', '39'],
  'esp32:esp32:esp32s3': ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48'],
};

export const DEFAULT_MQTT_HOST = process.env.REACT_APP_MQTT_HOST || '46.202.88.29';
export const DEFAULT_MQTT_PORT = Number(process.env.REACT_APP_MQTT_PORT || 1883);

// Must match services/otaTransfer.js OTA_CHUNK_SIZE and firmware sketch constant
export const OTA_CHUNK_SIZE = 4096;